// App
import React from 'react';

// Constellation
import { IconArrowLeftOutline, IconArrowRightOutline, Text } from '@zillow/constellation';

// Misc / utils
import * as S from './styles';
import IconPointer from '../images/icons/pointIcon.inline.svg';

const ScrollAlert = () => {
  return (
    <S.ScrollAlertWindowMobile>
      <S.ScrollAlertIconsMobile>
        <S.ScrollAlertIconArrow>
          <IconArrowLeftOutline fontColor="white" size="lg" />
        </S.ScrollAlertIconArrow>
        <S.ScrollAlertIconPointer>
          <IconPointer />
        </S.ScrollAlertIconPointer>
        <S.ScrollAlertIconArrow>
          <IconArrowRightOutline fontColor="white" size="lg" />
        </S.ScrollAlertIconArrow>
      </S.ScrollAlertIconsMobile>
      <Text fontType="bodyHeading" fontColor="white">
        Scrollable
      </Text>
    </S.ScrollAlertWindowMobile>
  );
};

export default ScrollAlert;
